/* eslint-disable max-len */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { deleteRecurringTask, updateTaskDetails } from '../../services/taskServices';
import {
  AssignGroup,
  AvatarImage,
  Deadline,
  Form,
  Group,
  Icon,
  Text as DetailTask,
  InputValue,
  Label,
  ProjectName,
  ProjectTitle,
  Task,
  TaskContent,
  TaskItem,
  Tasklist,
  TaskHeader,
  Heading,
  Title,
  Menu,
  TaskIcons,
  Filter,
  DueDate,
  ProjectDate,
  SelectText,
  TaskTitle,
  MainTaskTitle,
  DropBlock,
  DotIcon,
  DropLabel,
  MultipleLabel,
  IconDueDate,
  ResponsiveNavbarIcon,
  HeaderTitle,
  Div,
  EmptyBox,
  Empty,
  ButtonIcon,
  TooltipWrapper,
  SVGDiv,
  TooltipDiv,
  MainTooltipDiv
} from './styles';
import EmptyState from '../emptyState';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import Avatar from '../avatar/Avatar';
import Linkify from 'react-linkify';
import { calculateDueTime, isEmpty } from '../../helpers/common';
import myTaskEmpty from '../../assets/images/emptystates/lightMyTaskEmpty.svg';
import darkMyTaskEmpty from '../../assets/images/emptystates/darkMyTaskEmpty.svg';
import Button from '../button';
import AssignBoxV2 from '../dropdowns/assignPopup/assignPopupV2';
import {
  LABEL_COLOUR_HASH,
  MY_TASKS_GROUP_FILTER_TYPE,
  MY_TASKS_GROUP_FILTER_TYPE_LABELS,
  STATUS_TYPE
} from '../../global/constants';
import ModalCustom from '../models/modal';
import { useParams } from 'react-router-dom';
import ResButton from '../resbutton/resbutton';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import TaskLoading from '../loading/taskloading';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { MobxMyTaskModelInterface } from '../../interfaces/TaskInterface';
import { updateUserWorkspacePreference } from '../../helpers/firebaseHelper';
import moment from 'moment';
import { captureException } from '../../services/logService';
import DeleteModal from '../models/deleteModel';
import ConfirmationModal from '../models/confirmationModal';
import ResponsiveNavbar from '../navbar/responsiveNavbar';
import { useMobileDevice } from '../../global/useMobile';
import { TASK_ANALYTICS } from '../../global/analyticsConstants';
import { Dropdown, DropdownItem } from '../Dropdown';
import { menuItems } from '../../global/row';
import TasksCacheService from '../../services/tasksCatchServices';
import { selectTasksState } from '../../store/selectors';
import Tooltip from '../Tooltip';
import MyCustomContextMenuV2 from '../customContextMenu/customContextMenuV2';
import { TaskModel } from '../../mobx/models/task';
import { ProjectModel } from '../../mobx/models/project';
import TaskStatusDropdownV2 from '../dropdowns/taskStatusDropdown/taskStatusDropdownV2';
import PriorityDropDownV2 from '../dropdowns/priorityDropdown/priorityDropdownV2';
import { checkSubtaskStatus, onUpdateStatus } from '../../services/taskActionService';
import { dispatchTaskUpdates } from '../../services/taskActionService';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import CreateTaskModalV2 from '../models/createTaskModal/createTaskModalV2';
import { Taskcount } from '../../pages/project/details/tasks/styles';
import { clearCreateTaskInput } from '../../actions/taskActions';
interface Tasks {
  loading?: boolean;
  isMyTask?: boolean;
  loadData: () => void;
  data: MobxMyTaskModelInterface[];
  isMember?: boolean;
  memberId?: string;
  isRecurringTask?: boolean;
  myTasksFilter?: number;
}
interface AssignGroupComponentProps {
  onClickUsers: (taskId: string) => void;
  item: TaskModel;
  project: ProjectModel | undefined;
  isAssignDropdownOpen: boolean;
  setIsAssignDropdownOpen: (isOpen: boolean) => void;
  currentAssignBox: string;
  setCurrentAssignBox: (id: string) => void;
  loadData: () => void;
  mobile: boolean;
  isRecurringTask: boolean;
  className?: string;
  isMember?: boolean;
  isMyTask?: boolean;
}
export const AssignGroupComponent: React.FC<AssignGroupComponentProps> = ({
  onClickUsers,
  item,
  project,
  setIsAssignDropdownOpen,
  currentAssignBox,
  setCurrentAssignBox,
  className,
  isRecurringTask
}) => {
  return (
    <AssignGroup className={className}>
      <ul onClick={() => onClickUsers(item?.id)}>
        {item?.users
          ?.filter((user) => !!user?.id)
          ?.map((user) => (
            <li key={user?.id}>
              <AvatarImage>
                <Avatar imgSrc={user?.profile_photo || ''} name={user?.name} size={20} />
              </AvatarImage>
            </li>
          ))}
        <AssignBoxV2
          setIsDropdownOpen={setIsAssignDropdownOpen}
          projectUsers={project?.users || []}
          currentTask={item}
          setCurrentAssignBox={setCurrentAssignBox}
          currentAssignBox={currentAssignBox}
          isMultiAssignee={project?.multiAssignee}
          isRecurringTask={isRecurringTask}
        />
      </ul>
    </AssignGroup>
  );
};

const TasksDataV2: React.FC<Tasks> = (props) => {
  const { loading, isMyTask, loadData, data, isMember, isRecurringTask, myTasksFilter } = props;

  //State
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<TaskModel>();
  const [currentActiveTask, setCurrentActiveTask] = useState<string>('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [currentTask, setCurrentTask] = useState<TaskModel>();
  const [isConfirmationModelOpen, setIsConfirmationModelOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [status, setStatus] = useState<StatusListInterface>();
  const [previousStatus, setPreviousStatus] = useState<StatusListInterface>();
  const [editData, setEditData] = useState<TaskModel>();
  const [openCreateTask, setOpenCreateTask] = useState(false);
  const [isAssignDropdownOpen, setIsAssignDropdownOpen] = useState(false);
  const [currentAssignBox, setCurrentAssignBox] = useState<string>('');
  const [maxVisibleLabels, setMaxVisibleLabels] = useState(3);
  //use selector state variables with memoized selectors
  const { themeMode, userDetails } = useSelector(selectTasksState);

  //Mobx store variable
  const { workspaceStore, currentUser } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;

  //Other variable
  const params: { id: string } = useParams();
  const memberDetail = workspace?.users?.find((x: { id: string }) => x?.id === params?.id);
  const getImageSource = () => (themeMode?.theme === 'dark' ? darkMyTaskEmpty : myTaskEmpty);
  const mobile = useMobileDevice();
  const dispatch = useDispatch();
  const history = useHistory();

  const openCreateTaskModal = useCallback(async () => {
    if (isMyTask) {
      if (currentUser) rootStore.taskStore.createTaskInput.addAssignee(currentUser?.id);
    }
    setOpenCreateTask(true);
  }, [isMyTask, currentUser]);

  const closeCreateTaskModal = useCallback(() => {
    setOpenCreateTask(false);
    dispatch(clearCreateTaskInput());
  }, [dispatch]);

  const handleOpenConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(true);
  }, []);

  const closeConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(false);
  }, []);

  const onCLickProject = useCallback(
    (projectId: string, e: React.SyntheticEvent) => {
      e.stopPropagation();
      history.push(`/projects/details/${projectId}/tasks`);
    },
    [history]
  );

  const onClickEdit = useCallback(
    async (item: TaskModel) => {
      setEditData(item);
      if (isRecurringTask) {
        rootStore.taskStore.createTaskInput.updateWith(item);
      } else {
        rootStore.taskStore.createTaskInput.updateWith(item);
      }
      setOpenCreateTask(true);
    },
    [isRecurringTask]
  );

  const onClickClone = useCallback(async (item: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(item);
    rootStore.taskStore.createTaskInput.setDueDate(null);
    rootStore.taskStore.createTaskInput.setId(undefined);
    setOpenCreateTask(true);
  }, []);

  const onChangeGroupByFilter = useCallback(async (key: number | string) => {
    key = Number(key);
    rootStore.taskStore.setMyTasksFilter(key);
    // Update my tasks filter in workspace preference
    await updateUserWorkspacePreference({ my_task_filter: { group_by: key } });
  }, []);

  const openDeleteModel = useCallback((task?: TaskModel) => {
    if (task) setSelectedItem(task);
    setDeleteModelOpen(true);
  }, []);

  const deleteTask = useCallback(
    async (task: TaskModel) => {
      try {
        setDeleteLoading(true);
        if (!isRecurringTask) {
          const payloadTask = { isArchived: true, projectId: task?.projectId };
          const response = await dispatch(updateTaskDetails(task?.id, payloadTask));
          setDeleteModelOpen(false);
          if (response) {
            rootStore.taskStore.removeTasks([task?.id]);
            await TasksCacheService.getInstance().removeBulk([task?.id]);
          }
        } else {
          await dispatch(deleteRecurringTask(task?.id, task?.projectId));
          setDeleteModelOpen(false);
        }
      } catch (e) {
        captureException(e);
        console.log('ERROR', e);
      } finally {
        setDeleteLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, dispatch]
  );

  const close = () => {
    setDeleteModelOpen(false);
  };

  const onChangeStatus = useCallback(
    (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status.Type === STATUS_TYPE.COMPLETED && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setStatus(status);
        setPreviousStatus(previousStatus);
        setCurrentTask(task);
        return;
      }
      onUpdateStatus(task, status, previousStatus, false, dispatch);
    },
    [dispatch, handleOpenConfirmationModal]
  );

  //Handle checkbox click when project status is disabled
  const onClickTaskCheckBox = useCallback(
    (task: TaskModel, status: boolean) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setCurrentTask(task);
        return;
      }
      task.setStatus(status, false);
      dispatchTaskUpdates(task, status, dispatch);
    },
    [dispatch, handleOpenConfirmationModal]
  );

  //Handle Yes button click for confirmation model
  const onClickConfirm = useCallback(() => {
    if (!currentTask) return;
    try {
      setConfirmationLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, true, dispatch);
      } else {
        currentTask.setStatus(true, true);
        dispatchTaskUpdates(currentTask, true, dispatch);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setConfirmationLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, dispatch, previousStatus, status]);

  //Handle No button click for confirmation model
  const onClickNo = useCallback(() => {
    if (!currentTask) return;
    try {
      setCancelLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, false, dispatch);
      } else {
        currentTask.setStatus(true, false);
        dispatchTaskUpdates(currentTask, true, dispatch);
      }
    } catch (error) {
    } finally {
      setCancelLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, dispatch, previousStatus, status]);

  // logic for show task details
  const onClickTaskDetails = useCallback(
    (task: TaskModel) => {
      if (isRecurringTask) {
        return;
      }
      const eventProperties = {
        source: 'task list',
        title: task?.name || ''
      };
      trackAnalyticActivity(TASK_ANALYTICS.VIEW, eventProperties);
      rootStore.taskStore.setCurrentTask(task?.id);
      history.push(`/projects/details/${task?.projectId}/tasks?task=${task?.id}`);
    },
    [history, isRecurringTask]
  );

  const onClickUsers = useCallback(
    (taskId: string) => {
      if (mobile) {
        setIsAssignDropdownOpen(true);
        setCurrentAssignBox(taskId);
      }
    },
    [mobile]
  );

  const MenuItemDropdown = useMemo(() => {
    return menuItems.map((item) => (
      <DropdownItem label={item.label} key={item.key} onClick={() => onChangeGroupByFilter(item.key)} />
    ));
  }, [onChangeGroupByFilter]);

  useEffect(() => {
    const updateLabelLimit = () => {
      setMaxVisibleLabels(window.innerWidth > 1024 ? 4 : 3);
    };

    updateLabelLimit(); // Initial check
    window.addEventListener('resize', updateLabelLimit);
    return () => window.removeEventListener('resize', updateLabelLimit);
  }, []);

  const TaskFilter = useMemo(() => {
    let taskFilter = myTasksFilter;
    if (taskFilter === MY_TASKS_GROUP_FILTER_TYPE.GROUP) {
      taskFilter = MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE;
    }
    return (
      data?.length > 0 &&
      data[0]?.tasks?.length > 0 && (
        <TaskIcons>
          <Filter isHide={myTasksFilter === MY_TASKS_GROUP_FILTER_TYPE.NONE}>
            <SVGIcon
              name='small-filters-icon'
              width='16'
              height='16'
              viewBox='0 0 14 14'
              className='filters-icon-color'
            />
            <SelectText isHide={myTasksFilter === MY_TASKS_GROUP_FILTER_TYPE.NONE}>
              {MY_TASKS_GROUP_FILTER_TYPE_LABELS[taskFilter || MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE] || ''}
            </SelectText>
          </Filter>
        </TaskIcons>
      )
    );
  }, [data, myTasksFilter]);

  return (
    <Group>
      {isMyTask && (
        <TaskHeader>
          <HeaderTitle>
            <ResponsiveNavbarIcon>
              <ResponsiveNavbar />
            </ResponsiveNavbarIcon>
            <Heading>
              <Icon>
                <SVGIcon
                  name='my-task-main-icon'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  className='fill-color'
                />
              </Icon>
              <Title>{isRecurringTask ? 'Recurring Tasks' : 'My Tasks'}</Title>
            </Heading>
          </HeaderTitle>
          {!isRecurringTask && (
            <Menu>
              <Dropdown modalTitle='Group By' content={TaskFilter} trigger='click'>
                {MenuItemDropdown}
              </Dropdown>
              {/* hides button inresponsive screen and calls responsive button */}
              <div className='hidebutton'>
                {data?.length > 0 && data[0]?.tasks?.length > 0 && (
                  <Button
                    title='New Task'
                    iconName='plus-icon'
                    type='button'
                    iconSize={18}
                    iconViewBox='0 0 18 18'
                    iconColor='#fff'
                    onClick={openCreateTaskModal}
                  />
                )}
              </div>
              {data?.length > 0 && data[0]?.tasks?.length > 0 && (
                <ResButton onClick={openCreateTaskModal} className={'responsive-button'} />
              )}
            </Menu>
          )}
        </TaskHeader>
      )}
      {loading && (data?.length === 0 || !data) && <TaskLoading isMarginTop={true} isMember={isMember} />}
      {!loading && (data?.length === 0 || data[0]?.tasks?.length === 0) && !isMember && (
        <Empty>
          <EmptyBox>
            <EmptyState
              header={`You have no ${isRecurringTask ? 'Recurring' : ''} Tasks ${!isRecurringTask ? 'Assigned' : ''}`}
              title={
                isRecurringTask
                  ? ''
                  : 'You have no tasks assigned for now.You can add New task by clicking the button below'
              }
              onButtonClick={openCreateTaskModal}
              image={getImageSource()}
              name={'New Task'}
              hideButton={isRecurringTask}
              width={330}
            />
          </EmptyBox>
        </Empty>
      )}

      {!loading && data[0]?.tasks?.length === 0 && isMember && (
        <Empty>
          <EmptyBox>
            <EmptyState
              header={`${memberDetail?.name} has no Any Task`}
              title={`${memberDetail?.name} has no any task for now.You can add New task by clicking the button below`}
              onButtonClick={openCreateTaskModal}
              image={getImageSource()}
              name={'New Task'}
              width={330}
            />
          </EmptyBox>
        </Empty>
      )}
      <>
        <Div isMember={isMember}>
          {data?.length > 0 &&
            data[0]?.tasks?.length > 0 &&
            data?.map((group, index: number) => {
              return (
                <Task key={group?.title} isMember={isMember}>
                  {myTasksFilter !== MY_TASKS_GROUP_FILTER_TYPE.NONE && (
                    <Tasklist>
                      <ProjectTitle>{!isEmpty(group?.title) ? group?.title : ''}</ProjectTitle>
                    </Tasklist>
                  )}
                  {group?.tasks?.map((item, i: number) => {
                    const dueResult = calculateDueTime(item.dueDate);
                    return (
                      <>
                        <MyCustomContextMenuV2
                          key={i}
                          taskData={item}
                          loadData={loadData}
                          currentProject={item?.project!}
                          setCurrentActiveTask={(taskId: string) => setCurrentActiveTask(taskId)}
                          onClickView={() => onClickTaskDetails(item)}
                          onClickClone={() => onClickClone(item)}
                          onClickEdit={() => onClickEdit(item)}
                          onClickDelete={() => openDeleteModel(item)}
                          statusList={item.project?.statusData || []}
                          isMyTask={isMyTask}
                          isMember={isMember}
                          isRecurringTask={isRecurringTask}
                          onUpdateStatus={(status: StatusListInterface, previousStatus: StatusListInterface) =>
                            onChangeStatus(item, status, previousStatus)
                          }
                          isSubTask={!!item?.parentTaskId}>
                          <TaskContent
                            onClick={() => onClickTaskDetails(item)}
                            isActive={currentActiveTask === item?.id}
                            className={item?.subTasks ? 'task-item' : ''}>
                            <TaskItem>
                              <Form isTaskItem={true}>
                                <div style={{ display: 'flex', gap: 2 }}>
                                  {item?.statusId && item?.project?.statusEnable && !isRecurringTask ? (
                                    <TaskStatusDropdownV2
                                      defaultStatus={item?.project?.defaultStatus}
                                      statusList={item?.project?.statusData || []}
                                      currentStatusId={item?.statusId}
                                      isTaskCheckBox={true}
                                      onUpdateStatus={(
                                        status: StatusListInterface,
                                        previousStatus: StatusListInterface
                                      ) => onChangeStatus(item, status, previousStatus)}
                                      isHoverIcon={true}
                                    />
                                  ) : (
                                    <ButtonIcon>
                                      <InputValue
                                        type='checkbox'
                                        className='checkbox-round'
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={() => !isRecurringTask && onClickTaskCheckBox(item, !item?.status)}
                                        checked={item?.status}
                                      />
                                    </ButtonIcon>
                                  )}
                                  <PriorityDropDownV2
                                    taskData={item}
                                    currentProject={item?.project!}
                                    myTask={true}
                                    isTaskCheckBox={true}
                                    isHoverIcon={true}
                                    isRecurringTask={isRecurringTask}
                                  />
                                </div>
                                <Linkify
                                  componentDecorator={(decoratedHref: string, decoratedText: string, key: number) => (
                                    <a target='blank' href={decoratedHref} key={key}>
                                      {decoratedText}
                                    </a>
                                  )}>
                                  {isEmpty(item?.parentTaskId) ? (
                                    <Label isMainTask>{item?.name}</Label>
                                  ) : (
                                    <TaskTitle onClick={() => onClickTaskDetails(item)}>
                                      <Label>{item?.name}</Label>
                                      <SVGDiv>
                                        <SVGIcon
                                          name='myTask-right-arrow-icon'
                                          width='12'
                                          height='12'
                                          viewBox='0 0 18 18'
                                          fill='var(--text-secondary)'
                                        />
                                      </SVGDiv>
                                      <MainTaskTitle>{item?.parentTask?.name || ''}</MainTaskTitle>
                                    </TaskTitle>
                                  )}
                                </Linkify>
                                {item?.subTasks && item?.subTasks?.length > 0 && (
                                  <Taskcount>
                                    {item?.subTasks?.filter((x) => x?.status)?.length}/{item?.subTasks?.length}
                                  </Taskcount>
                                )}
                              </Form>
                              <AssignGroupComponent
                                className='assign'
                                onClickUsers={onClickUsers}
                                item={item}
                                project={item?.project!}
                                isAssignDropdownOpen={isAssignDropdownOpen}
                                setIsAssignDropdownOpen={setIsAssignDropdownOpen}
                                currentAssignBox={currentAssignBox}
                                setCurrentAssignBox={setCurrentAssignBox}
                                loadData={loadData}
                                mobile={mobile}
                                isRecurringTask={isRecurringTask || false}
                                isMember={isMember}
                                isMyTask={isMyTask}
                              />
                            </TaskItem>
                            <Deadline>
                              <AssignGroupComponent
                                className='respassign'
                                onClickUsers={onClickUsers}
                                item={item}
                                project={item?.project!}
                                isAssignDropdownOpen={isAssignDropdownOpen}
                                setIsAssignDropdownOpen={setIsAssignDropdownOpen}
                                currentAssignBox={currentAssignBox}
                                setCurrentAssignBox={setCurrentAssignBox}
                                loadData={loadData}
                                mobile={mobile}
                                isRecurringTask={isRecurringTask || false}
                                isMember={isMember}
                                isMyTask={isMyTask}
                              />

                              {item?.labels?.length > 0 && (
                                <MultipleLabel>
                                  {item?.labels?.map((label, index) => {
                                    if (index < maxVisibleLabels) {
                                      return (
                                        <DropBlock className={index === 0 ? 'left-border' : ''} key={label?.id}>
                                          <DotIcon color={`${LABEL_COLOUR_HASH[label?.color]}`} />
                                          <DropLabel>{label?.name}</DropLabel>
                                        </DropBlock>
                                      );
                                    } else if (index === maxVisibleLabels) {
                                      const remainingLabels = item.labels.length - maxVisibleLabels;
                                      if (remainingLabels > 0) {
                                        const tooltipContent = (
                                          <MainTooltipDiv>
                                            {item.labels.slice(maxVisibleLabels).map((l) => (
                                              <TooltipDiv key={l.id}>
                                                <DotIcon color={`${LABEL_COLOUR_HASH[l.color]}`} />
                                                <span>{l.name}</span>
                                              </TooltipDiv>
                                            ))}
                                          </MainTooltipDiv>
                                        );
                                        return (
                                          <Tooltip title={tooltipContent} maxWidth='max-content' key={label?.id}>
                                            <DropBlock>
                                              <DropLabel>+{remainingLabels} more</DropLabel>
                                            </DropBlock>
                                          </Tooltip>
                                        );
                                      }
                                    }
                                    return null;
                                  })}
                                </MultipleLabel>
                              )}
                              <ProjectDate>
                                <ProjectName
                                  isRecurringTask={isRecurringTask}
                                  showRightBorder={!!item?.dueDate}
                                  onClick={(e) => onCLickProject(item?.projectId, e)}>
                                  <p>{item?.project?.name}</p>
                                </ProjectName>
                                <DueDate>
                                  {item?.dueDate && !isRecurringTask && (
                                    <>
                                      <Tooltip
                                        title={
                                          <>
                                            <div>Due {dueResult?.dueParam}</div>
                                            <div> Due on {moment(item?.dueDate).format(userDetails?.dateFormat)}</div>
                                          </>
                                        }
                                        placement='bottom'
                                        maxWidth={'max-content'}>
                                        <TooltipWrapper>
                                          <DetailTask isOverdue={dueResult?.overDue}> {dueResult?.dueTime} </DetailTask>
                                          <IconDueDate className='calendar-icon' onClick={(e) => e.stopPropagation()}>
                                            {dueResult?.overDue && !item?.status ? (
                                              <SVGIcon
                                                name='tasklist-calendar-duedate-icon'
                                                width='24'
                                                height='24'
                                                viewBox='0 0 24 24'
                                                className='calendar-due-fill-color'
                                              />
                                            ) : (
                                              <SVGIcon
                                                name='tasklist-calendar-icon'
                                                width='24'
                                                height='24'
                                                viewBox='0 0 24 24'
                                                className='calendar-fill-color'
                                              />
                                            )}
                                          </IconDueDate>
                                        </TooltipWrapper>
                                      </Tooltip>
                                    </>
                                  )}
                                </DueDate>
                              </ProjectDate>
                            </Deadline>
                          </TaskContent>
                        </MyCustomContextMenuV2>
                        {/* show subtask ui */}
                      </>
                    );
                  })}
                </Task>
              );
            })}
        </Div>
      </>
      <ModalCustom open={openCreateTask} onClose={closeCreateTaskModal} isCreateTask={true}>
        <CreateTaskModalV2
          isRecurringTask={isRecurringTask}
          data={editData}
          loadData={loadData}
          onCancel={closeCreateTaskModal}
          isFromMyTask={true}
        />
      </ModalCustom>

      <ModalCustom open={deleteModelOpen} onClose={close} width={334}>
        <DeleteModal
          onClose={close}
          onOk={() => selectedItem && deleteTask(selectedItem)}
          loading={deleteLoading}
          modalTitle={`${
            (selectedItem?.subTasks?.length ?? 0) > 0
              ? `Delete this task and ${selectedItem?.subTasks?.length} subtasks?`
              : 'Delete Task?'
          }`}
          description={`${
            (selectedItem?.subTasks?.length ?? 0) > 0
              ? 'This action will remove this task and all its connected subtasks.'
              : 'Are you sure you want to delete this task?'
          }`}
        />
      </ModalCustom>

      <ModalCustom open={isConfirmationModelOpen} onClose={closeConfirmationModal} width={334}>
        <ConfirmationModal
          loading={confirmationLoading}
          cancelLoading={cancelLoading}
          onOk={onClickConfirm}
          onNo={onClickNo}
          onClose={closeConfirmationModal}
          modalTitle='Uncompleted Subtasks'
          description='Do you want to complete all these subtasks?'
        />
      </ModalCustom>
    </Group>
  );
};

export default observer(TasksDataV2);
